/* eslint-disable no-return-assign, no-unused-vars, consistent-return */

import jQuery from 'jquery';
import _ from 'lodash';
import async from 'app/legacy/vendor/async';

let $;

$ = jQuery;

$.fn.extend({
  /* Makes the selector enter a mode. Modes have both a 'mode' and a 'group',
   * and are mutually exclusive with any other modes in the same group.
   * Setting will update the view's modes hash, as well as set an HTML class
   * of *[mode]_[group]* on the view's element. Convenient way to swap styles
   * and behavior.
   */
  setMode: function(state, group) {
    let mode, re;
    group = group || 'mode';
    re = new RegExp('\\w+_' + group + '(\\s|$)', 'g');
    mode = state == null ? '' : state + '_' + group;
    this.each(function() {
      return (this.className = (
        this.className.replace(re, '') +
        ' ' +
        mode
      ).replace(/\s\s/g, ' '));
    });
    return mode;
  },

  // Return true if ths elector has a particular mode.
  hasMode: function(state, group) {
    let has, mode, re;
    group = group || 'mode';
    re = new RegExp('\\w+_' + group + '(\\s|$)', 'g');
    mode = state == null ? '' : state + '_' + group;
    has = $(this).hasClass(mode);
    return has;
  },

  /* Set default retina file part to '-2x'
   * Eg. some_image.jpg will become some_image-2x.jpg
   */
  retina: function(retina_part) {
    let settings;
    settings = {
      retina_part: '@2x',
    };
    if (retina_part) {
      jQuery.extend(settings, {
        retina_part,
      });
    }
    if (window.devicePixelRatio >= 2) {
      this.each(function(index, el) {
        let checkForRetina, new_image_src;
        el = $(el);
        if (!el.attr('src')) {
          return;
        }
        checkForRetina = new RegExp(
          '(.+)(' + settings.retina_part + '\\.\\w{3,4})'
        );
        if (checkForRetina.test(el.attr('src'))) {
          return;
        }
        new_image_src = el
          .attr('src')
          .replace(/(.+)(\.\w{3,4})$/, '$1' + settings.retina_part + '$2');
        return $.ajax({
          url: new_image_src,
          type: 'HEAD',
          success: function() {
            el.attr('height', el.height());
            el.attr('width', el.width());
            return el.attr('src', new_image_src);
          },
        });
      });
    }
    return this;
  },
  loadYoutubeVideo: function() {
    let t, youtubeId;
    t = $(this);
    youtubeId = t.attr('data-youtubeid');
    t.on('click', function() {
      t.removeClass('video');
      return t.html(
        '<iframe class="" width="460" height="259" src="https://www.youtube.com/embed/' +
          youtubeId +
          '?rel=0&amp;wmode=transparent&amp;showinfo=0&amp;theme=light&amp;autohide=1&amp;autoplay=1" frameborder="0" allowfullscreen></iframe>'
      );
    });
    return this;
  },
});

$.getScripts = function(urls, originalCallback) {
  /*
  A handy way to sideload js, but only do it once. Can use like:

     $.getScripts [
        '#{z.cfg.mediaURL}sideload/codemirror/mode/javascript.js',
        '#{z.cfg.mediaURL}sideload/codemirror/plugins/matchbrackets.js'
     ], () ->
        log 'All done!'

  Or:

     async.series [
        $.getScripts([
           '#{z.cfg.mediaURL}sideload/codemirror/mode/javascript.js',
           '#{z.cfg.mediaURL}sideload/codemirror/plugins/matchbrackets.js'
        ]),
        loadModels,
        renderViews
     ], () ->
        log 'All done!'
   */
  let scripts;
  $._alreadyLoadedScripts = $._alreadyLoadedScripts || {};
  urls = _.filter(urls, function(url) {
    return !$._alreadyLoadedScripts[url];
  });
  scripts = _.map(urls, function(url) {
    return function(cb) {
      return $.getScript(url, function(script, textStatus, jqXHR) {
        $._alreadyLoadedScripts[url] = true;
        return cb();
      });
    };
  });
  if (_.isFunction(originalCallback)) {
    return async.parallel(scripts, originalCallback);
  } else {
    return function(callback) {
      return async.parallel(scripts, function() {
        return callback();
      });
    };
  }
};
